export const createAppErrorClass = <T>(name: string) => {
  const appError = class extends Error {
    constructor(message: string, additionalData?: T) {
      super(message)
      const trueProto = new.target.prototype
      Object.setPrototypeOf(this, trueProto)
      Object.assign(this, additionalData)
    }
  }
  Object.defineProperty(appError, 'name', { value: name })
  return appError
}
